import { RazorInputField } from "../../../../components/razor-reuse";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReuseModal from "../../../../components/fragment/modal/ReuseModal";
import RootState from "../../../../redux/type";
import {
  editRemittanceRule,
  getRemittanceRules,
} from "../../../../redux/featureMgt";
import { thresholdProp } from "../ACHNowManagement";

interface myComponentProps {
  onClose?: () => void;
  visible?: boolean;
  onComplete?: () => void;
  data: thresholdProp;
}

type formProp = {
  min_spend: String;
  max_spend: String;
  smartsend_remit: String;
};

const EditThresholdModal = ({
  onClose,
  visible,
  onComplete,
  data,
}: myComponentProps) => {
  const dispatch = useDispatch();
  const { mutating } = useSelector((state: RootState) => state.feature_mgt);

  const [details, setDetails] = useState<formProp>({
    min_spend: "",
    max_spend: "",
    smartsend_remit: "",
  });

  useEffect(() => {
    setDetails({
      min_spend: data?.min_spend || "",
      max_spend: data?.max_spend || "",
      smartsend_remit: data?.smartsend_remit || "",
    });
  }, [data]);

  const handleSubmit = async () => {
    const body = {
      ...details,
      smartsend_without_value: data?.smartsend_without_value === 1,
    };
    const res = await dispatch(
      editRemittanceRule({ id: data.id, body }) as any
    );

    if (res?.payload?.data?.status) {
      setDetails({
        min_spend: "",
        max_spend: "",
        smartsend_remit: "",
      });
      dispatch(getRemittanceRules({ page: 1 }) as any);
      onComplete && onComplete();
    }
  };

  const handleClose = () => {
    setDetails({
      min_spend: "",
      max_spend: "",
      smartsend_remit: "",
    });
    onClose && onClose();
  };

  return (
    <>
      <ReuseModal
        title="Remittance Threshold"
        btnLabel="Update"
        visible={visible}
        onClose={handleClose}
        disable={
          !details.min_spend ||
          !details.smartsend_remit ||
          !details.max_spend ||
          mutating
        }
        loading={mutating}
        onBtnClick={handleSubmit}
      >
        <div className="add-exchange-currency-modal-wraps space-y-[20px]">
          <>
            <RazorInputField
              value={details?.min_spend}
              color="black-light"
              label="Minimum Limit ($)"
              type={`number`}
              placeholder="Enter Amount e.g(1,000)"
              onChange={(e: any) => {
                const val = e.target.value;
                if (val === "" || (/^\d+$/.test(val) && Number(val) >= 0))
                  setDetails((prev) => ({ ...prev, min_spend: val }));
              }}
              // thousandFormat
            />
            <RazorInputField
              value={details?.max_spend}
              color="black-light"
              label="Maximum Limit ($)"
              type={`number`}
              placeholder="Enter Amount e.g(1,000)"
              onChange={(e: any) => {
                const val = e.target.value;
                if (val === "" || (/^\d+$/.test(val) && Number(val) >= 0))
                  setDetails((prev) => ({ ...prev, max_spend: val }));
              }}
              // thousandFormat
            />
            <RazorInputField
              value={details?.smartsend_remit}
              color="black-light"
              label="Highest Transaction Threshold ($)"
              type={`number`}
              placeholder="Enter Amount e.g(1,000)"
              onChange={(e: any) => {
                const val = e.target.value;
                if (val === "" || (/^\d+$/.test(val) && Number(val) >= 0))
                  setDetails((prev) => ({ ...prev, smartsend_remit: val }));
              }}
              // thousandFormat
            />
          </>
        </div>
      </ReuseModal>
    </>
  );
};

export default EditThresholdModal;
